export default (function(value) {
  return typeof value === "function";
});
